import React from "react";
import PropTypes from "prop-types";
import styles from "components/common/checkbox.scss";

export const Checkbox = ({ checked, disabled, onChange }) => (
  <button className={ classNames(checked) } disabled={ disabled } onClick={ onChange } type="button" />
);

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

Checkbox.defaultProps = {
  disabled: false
};

const classNames = (checked) => (
  checked ? styles["container--checked"] : styles.container
);



// WEBPACK FOOTER //
// ./src/js/components/common/checkbox.jsx